import React, { memo } from "react";
import { DepotBoundary } from "./DepotBoundary";
import { DepotPostcodeLabelsLayer } from "./DepotPostcodeLabelsLayer";
import { MultiPatternLayer } from "./MultiPatternLayer";
import { ArtificialPostcodesLayer } from "./ArtificialPostcodesLayer/ArtificialPostcodesLayer";
import { RouteLabelLayer } from "./RouteLabelLayer/RouteLabelLayer";
import ScheduledCollectionLayer from "./ScheduledCollectionsLayer";
import { LocationLayer } from "./LocationLayer/";
import { DepotLabelLayer } from "./DepotLabelLayer";
import { RobotSupplierRangeLayer } from "./RobotSuplierRangeLayer";
import { DriverLocationsLayer } from "./DriverLocationsLayer";

export const Layers = memo(({ map }) => {
  return map ? (
    <>
      <DepotBoundary map={map} />
      <MultiPatternLayer />
      <DepotPostcodeLabelsLayer />
      <ArtificialPostcodesLayer />
      <DepotLabelLayer />
      <LocationLayer />
      <RouteLabelLayer />
      <ScheduledCollectionLayer />
      <RobotSupplierRangeLayer />
      <DriverLocationsLayer />
    </>
  ) : null;
});
